var _defs, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFullScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.794,
    height: 18.794,
    viewBox: "0 0 18.794 18.794",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#212548;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "as",
    d: "M18.794,1.175v4.5a1.175,1.175,0,0,1-2.349,0V4.01l-4.01,4.01a1.175,1.175,0,0,1-1.661-1.661l4.01-4.01H13.122a1.175,1.175,0,1,1,0-2.349h4.5a1.175,1.175,0,0,1,1.175,1.175Zm-12.435,9.6-4.01,4.01V13.122a1.175,1.175,0,1,0-2.349,0v4.5a1.175,1.175,0,0,0,1.175,1.175h4.5a1.175,1.175,0,0,0,0-2.349H4.01l4.01-4.01a1.175,1.175,0,0,0-1.661-1.661Z",
    transform: "translate(0 0)",
    fill: "#212547"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullScreen);
export default __webpack_public_path__ + "static/media/full-screen.433a66ab10b121e926eb48cdaad1eca3.svg";
export { ForwardRef as ReactComponent };